import React, { FC } from 'react';

import { getIsMuiSymbolIconName } from './helpers';
import {
  IconName,
  mappingMaterialSymbolIcon,
  muiIconMappings,
} from './mapping';
import { IconPropsExtended } from './types';

type Props = {
  icon: IconName;
} & IconPropsExtended;

/**
 * Standardized MUI Icon component
 *
 * @param props      Props passed to the component
 * @param props.icon The icon to display
 * @returns          The component itself
 */
const MuiIcon: FC<Props> = ({ icon, ...props }) => {
  const isSymbolIcon = getIsMuiSymbolIconName(icon);

  const IconComponent = isSymbolIcon
    ? mappingMaterialSymbolIcon[icon]
    : muiIconMappings[icon];

  return <IconComponent {...props} />;
};

export default MuiIcon;
